import { useInfiniteQuery } from "react-query";
import {
  useAmpLibraryFilesQuery,
  type AmpLibraryFilesQueryVariables,
} from "src/graphql";

/** Library files a page at a time. A null `folderId` lists unfiled files; leaving it out lists every folder. */
export function useFilePages(
  variables: Omit<AmpLibraryFilesQueryVariables, "offset">,
  { enabled = true }: { enabled?: boolean } = {},
) {
  const query = useInfiniteQuery(
    [...useAmpLibraryFilesQuery.getKey(variables), "pages"],
    ({ pageParam = 0 }) =>
      useAmpLibraryFilesQuery.fetcher({ ...variables, offset: pageParam })(),
    {
      enabled,
      getNextPageParam: (lastPage) =>
        lastPage.listAmpFiles.nextOffset ?? undefined,
    },
  );
  return {
    ...query,
    // A disabled query is idle, not loading, but it still has no files to show.
    isLoading: query.isLoading || query.isIdle,
    files: query.data?.pages.flatMap((page) => page.listAmpFiles.items) ?? [],
  };
}
